import { render, staticRenderFns } from "./MnemonicForm.vue?vue&type=template&id=9d5b1058&"
import script from "./MnemonicForm.vue?vue&type=script&lang=js&"
export * from "./MnemonicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports